import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { formValueSelector, FormSection } from 'redux-form';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import {
  AutoComplete,
  Date,
  DateField,
  Input,
  InputField,
  RadioSwitch,
  RadioSwitchField,
  RemoteAutoComplete,
  RemoteAutoCompleteField,
  AutoCompleteField,
  Toggle,
  ToggleField
} from '@components/form';
import { delictStateEnum, delictResolutionEnum } from '@modules/events/_eventsEnums';

const enhance = connect(state => ({
  eventId: formValueSelector('DelictsGrid')(state, 'event.id'),
  noticeOfficer: formValueSelector('DelictsGrid')(state, 'noticeOfficer')
}));

const View: React.SFC<any> = ({ eventId, noticeOfficer }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Základní informace</h4>
            </Col>
          </Row>
          {[
            { name: 'isepId', label: 'Identifikátor v systému ISEP' },
            { name: 'number', label: 'Sekvenční číslo' }
          ].map(({ name, label }) => (
            <Col md={12} key={name}>
              <InputField component={Input} name={name} label={label} disabled={true} />
            </Col>
          ))}
          <Col md={12}>
            <RemoteAutoCompleteField
              component={RemoteAutoComplete}
              id="officer"
              name="officer"
              label="Autor"
              url="/metropolis/api/hr/employees"
              labelFunction={o => get(o, 'fullName')}
              fullWidth={true}
              disabled={true}
            />
          </Col>
          <Col md={12}>
            <InputField component={Input} name={'event.number'} label={'Událost'} disabled={true} />
          </Col>
          <Col md={12}>
            <Button
              containerElement={<Link to={`/events?item=${eventId}`} />}
              label="Událost"
              style={{ width: '100%' }}
            />
          </Col>
        </Col>
        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Zákon</h4>
            </Col>
          </Row>
          <FormSection name="type">
            {[
              { name: 'law', label: 'Zákon' },
              { name: 'paragraph', label: 'Paragraf' },
              { name: 'novel', label: 'Novela' },
              { name: 'letter', label: 'Písmeno' },
              { name: 'section', label: 'Odstavec' },
              { name: 'pointOfLetter', label: 'Bod' }
            ].map(({ name, label }) => (
              <Row key={name}>
                <Col md={12}>
                  <InputField component={Input} name={name} label={label} disabled={true} />
                </Col>
              </Row>
            ))}
          </FormSection>
        </Col>
        <Col md={4} xl={2} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Přestupce</h4>
            </Col>
          </Row>
          {[
            {
              name: 'vehicle.registrationNumber',
              label: 'Vozidlo přestupce'
            },
            { name: 'offender.person.fullName', label: 'Přestupce' }
          ].map(({ name, label }) => (
            <Row key={name}>
              <Col md={12}>
                <InputField component={Input} name={name} label={label} disabled={true} />
              </Col>
            </Row>
          ))}
          <Row style={{ height: '72px' }}>
            <Col md={12} style={{ position: 'relative' }}>
              {noticeOfficer ? (
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  id="noticeOfficer"
                  name="noticeOfficer"
                  label="Vyrozumění"
                  url="/metropolis/api/hr/employees"
                  labelFunction={o => get(o, 'fullName')}
                  fullWidth={true}
                  disabled={true}
                />
              ) : (
                <ToggleField
                  component={Toggle}
                  style={{ margin: '10px 0', position: 'absolute', bottom: 0 }}
                  name="towPayed"
                  label="Odtah proveden"
                  labelPosition="right"
                  disabled={true}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{ marginTop: 15 }}>
                <RadioSwitchField
                  component={RadioSwitch}
                  name="intention"
                  label2="Nedbalost"
                  label1="Úmysl"
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={6} xl={3} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Data</h4>
            </Col>
          </Row>
          {[
            { name: 'date', label: 'Datum a čas přestupku' },
            { name: 'resolutionDate', label: 'Datum a čas vyřešení' },
            { name: 'closeDate', label: 'Datum a čas uzavření' },
            { name: 'isepCheckDatetime', label: 'Datum a čas opisu z ISEP' },
            { name: 'isepDate', label: 'Datum a čas zápisu ISEP' }
          ].map(({ name, label }) => (
            <Row key={name}>
              <Col md={12}>
                <DateField component={Date} name={name} label={label} dateOnly={false} disabled={true} />
              </Col>
            </Row>
          ))}
        </Col>
        <Col md={6} xl={3} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Řešení</h4>
            </Col>
          </Row>
          {[
            { name: 'type.fullName', label: 'Typ přestupku' },
            {
              name: 'discovery.name',
              label: 'Způsob zjištění'
            }
          ].map(props => (
            <Row key={props.name}>
              <Col md={12}>
                <InputField component={Input} disabled={true} {...props} />
              </Col>
            </Row>
          ))}
          {[
            { name: 'state', label: 'Stav', items: delictStateEnum },
            { name: 'resolution', label: 'Způsob řešení', items: delictResolutionEnum }
          ].map(field => (
            <Row key={name}>
              <Col md={12}>
                <AutoCompleteField
                  component={AutoComplete}
                  fullWidth={true}
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                  disabled={true}
                  {...field}
                />
              </Col>
            </Row>
          ))}
          <RemoteAutoCompleteField
            component={RemoteAutoComplete}
            id="resolutionOfficer"
            name="resolutionOfficer"
            label="Řešitel"
            url="/metropolis/api/hr/employees"
            labelFunction={o => get(o, 'fullName')}
            fullWidth={true}
            disabled={true}
          />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const DelictsFormBasic = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsFormBasic.tsx